var quantityLabel = "Antal";
var quantityFlyoutHeader = "Vælg antal";
var quantityFlyoutCTA = "Vælg dette antal";
var closeButton = "Luk";
var pricePlaceholder = "...";
var priceLabel = "Pris";
var unitPriceLabel = "Stykpris";
var incompatibilityMessage = "Ikke tilgængelig sammen med andre valg: ";
var select = "Vælg...";
var percentSavings = "{{{PERCENT}}}% besparelser";
var sale = "udsalg";
var amountSavings = "{{{AMOUNT}}} besparelser/stk.";
var amountSavingsWithSale = "{{{AMOUNT}}} besparelser/stk. + udsalg";
var seeMoreQuantities = "Se flere mængder";
var required = "Skal udfyldes";
var sample = "Vareprøve";
var estimatedQuantity = "Estimeret antal";
var numberOfRecipients = "{{{COUNT}}} Modtagere";
var recommendedCallout = "Anbefalet";
var newCallout = "Nyt";
var incompatibleLabel = "Inkompatibel";
var outOfStockCallout = "Ikke på lager";
var dismissAlert = "Luk meddelelse";
var unwindingMessage_1 = "Inkompatibel med {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2 = "Inkompatibel med {{{ATTRIBUTE1}}} {{{OPTION1}}} og {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3 = "Inkompatibel med {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} og {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more = "Inkompatibel med mere end {{{ATTRIBUTE_COUNT}}} valgmuligheder.";
var unwindingAlertMessage_1 = "For at være kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} blev fravalgt.";
var unwindingAlertMessage_2 = "For at være kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} og {{{ATTRIBUTE2}}} {{{OPTION2}}} blev fravalgt.";
var unwindingAlertMessage_3 = "For at være kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} og {{{ATTRIBUTE3}}} {{{OPTION3}}} blev fravalgt.";
var unwindingAlertMessage_more = "For at være kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: Mere end {{{ATTRIBUTE_COUNT}}} valgmuligheder blev fravalgt.";
var fullRangedHelperText = "{{{MINIMUM}}} {{{UNIT}}} til {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "Mindst {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Indtast en værdi mellem {{{MINIMUM}}} og {{{MAXIMUM}}} sider, inklusive forside ";
var rangePartialRangedHelperTextForBooklets = "Mindst {{{MINIMUM}}} sider, inklusive forside ";
var rangedGeneralInputError = "Inputtet er ugyldigt";
var rangedBetweenRangesError = "De nærmeste tal er {{{LOWER}}} {{{UNIT}}} og {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError = "Tallet må ikke have over 8 decimaler";
var rangedMinInputValueError = "Minimumtallet er {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError = "Maksimumtallet er {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError = "Det indtastede skal være et tal";
var requiredAttributeFieldError = "Indtast en værdi mellem {{{LOWER}}} og {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets = "Det tætteste antal er {{{LOWER}}} sider og {{{HIGHER}}} sider ";
var rangedMinInputValueErrorForBooklets = "Minimumsantallet er {{{MINIMUM}}} sider ";
var rangedMaxInputValueErrorForBooklets = "Maksimumsantallet er {{{MAXIMUM}}} sider ";
var requiredAttributeFieldErrorForBooklets = "Indtast en værdi mellem {{{LOWER}}} og {{{HIGHER}}} sider, inklusive forside ";
var requiredInformationToast = "Giv os alle de nødvendige oplysninger.";
var daDk = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast
};

export { amountSavings, amountSavingsWithSale, closeButton, daDk as default, dismissAlert, estimatedQuantity, fullRangedHelperText, fullRangedHelperTextForBooklets, incompatibilityMessage, incompatibleLabel, newCallout, numberOfRecipients, outOfStockCallout, percentSavings, priceLabel, pricePlaceholder, quantityFlyoutCTA, quantityFlyoutHeader, quantityLabel, rangePartialRangedHelperText, rangePartialRangedHelperTextForBooklets, rangedBetweenRangesError, rangedBetweenRangesErrorForBooklets, rangedDecimalPrecisionError, rangedGeneralInputError, rangedMaxInputValueError, rangedMaxInputValueErrorForBooklets, rangedMinInputValueError, rangedMinInputValueErrorForBooklets, rangedNotANumberError, recommendedCallout, required, requiredAttributeFieldError, requiredAttributeFieldErrorForBooklets, requiredInformationToast, sale, sample, seeMoreQuantities, select, unitPriceLabel, unwindingAlertMessage_1, unwindingAlertMessage_2, unwindingAlertMessage_3, unwindingAlertMessage_more, unwindingMessage_1, unwindingMessage_2, unwindingMessage_3, unwindingMessage_more };
//# sourceMappingURL=da-dk.json.mjs.map
